export const detectBraveBrowser = (): boolean => {
  if (typeof window === "undefined") {
    return false;
  }

  if ((navigator as any).brave) {
    if (typeof (navigator as any).brave.isBrave === "function") {
      try {
        return (navigator as any).brave.isBrave();
      } catch {
        return true;
      }
    }
    return true;
  }

  const userAgent = navigator.userAgent;
  if (userAgent.includes("Brave/") || userAgent.includes("Brave ")) {
    return true;
  }

  if (/Chrome\//.test(userAgent) && !/Edg\//.test(userAgent)) {
    try {
      const chrome = (window as any).chrome;
      const isWebstoreBlocked = typeof chrome?.webstore === "undefined" && typeof chrome !== "undefined";
      const hasPluginBlocking = navigator.plugins.length === 0 && navigator.mimeTypes.length === 0;
      if (isWebstoreBlocked && hasPluginBlocking) {
        return true;
      }
    } catch {
      return false;
    }
  }

  return false;
};
